"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SOCKET_CONNECTION = exports.SET_REMOVE_NOTIFICATION = exports.SET_NOTIFICATION_UNREAD_LIST = exports.SET_NOTIFICATION_LIST = exports.SET_NOTIFICATION_ALL_LIST = exports.SET_NEW_MESSAGE = exports.SET_NEW_HEADER_MESSAGE = exports.SET_NEW_ANNOUNCEMENT = exports.SET_MARK_AS_READ = exports.SET_HEADER_LIST = exports.SET_ANNOUNCEMENT_LIST = exports.RESET_NOTIFICATION_ALL_LIST = void 0;
const SET_NOTIFICATION_ALL_LIST = 'SET_NOTIFICATION_ALL_LIST';
exports.SET_NOTIFICATION_ALL_LIST = SET_NOTIFICATION_ALL_LIST;
const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST';
exports.SET_NOTIFICATION_LIST = SET_NOTIFICATION_LIST;
const SET_SOCKET_CONNECTION = 'SET_SOCKET_CONNECTION';
exports.SET_SOCKET_CONNECTION = SET_SOCKET_CONNECTION;
const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE';
exports.SET_NEW_MESSAGE = SET_NEW_MESSAGE;
const SET_NEW_ANNOUNCEMENT = 'SET_NEW_ANNOUNCEMENT';
exports.SET_NEW_ANNOUNCEMENT = SET_NEW_ANNOUNCEMENT;
const SET_ANNOUNCEMENT_LIST = 'SET_ANNOUNCEMENT_LIST';
exports.SET_ANNOUNCEMENT_LIST = SET_ANNOUNCEMENT_LIST;
const SET_NEW_HEADER_MESSAGE = 'SET_NEW_HEADER_MESSAGE';
exports.SET_NEW_HEADER_MESSAGE = SET_NEW_HEADER_MESSAGE;
const SET_HEADER_LIST = 'SET_HEADER_LIST';
exports.SET_HEADER_LIST = SET_HEADER_LIST;
const SET_NOTIFICATION_UNREAD_LIST = 'SET_NOTIFICATION_UNREAD_LIST';
exports.SET_NOTIFICATION_UNREAD_LIST = SET_NOTIFICATION_UNREAD_LIST;
const RESET_NOTIFICATION_ALL_LIST = 'RESET_NOTIFICATION_ALL_LIST';
exports.RESET_NOTIFICATION_ALL_LIST = RESET_NOTIFICATION_ALL_LIST;
const SET_MARK_AS_READ = 'SET_MARK_AS_READ';
exports.SET_MARK_AS_READ = SET_MARK_AS_READ;
const SET_REMOVE_NOTIFICATION = 'SET_REMOVE_NOTIFICATION';
exports.SET_REMOVE_NOTIFICATION = SET_REMOVE_NOTIFICATION;